<!--设置各列数据对应关系-->
<template>
  <div class="page-container">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div class="content-wrapper">
          <!-- 页面标题 -->
          <div class="page-header">
            <div class="header-content">
              <i class="el-icon-setting header-icon"></i>
              <span>设置查询条件</span>
            </div>
          </div>

          <!-- 主要内容区 -->
          <div class="main-content">
            <!-- 数据统计提示 -->
            <div class="info-card">
              <div class="info-icon">
                <i class="el-icon-info"></i>
              </div>
              <div class="info-text">
                预计可导入 <span class="highlight">{{dataList.length}}条</span> 数据，请按照下面的步骤设置好各项内容：
              </div>
            </div>

            <!-- 步骤1：输入查询名称 -->
            <div class="step-card">
              <div class="step-header">
                <span class="step-number">1</span>
                <span class="step-title">输入查询名称 <span class="required">*</span></span>
              </div>
              <div class="step-content">
                <el-input 
                  v-model="form_name" 
                  placeholder="输入查询名称,如xx工资条,xx分班表,xx成绩单等" 
                  class="custom-input"
                  size="medium">
                </el-input>
              </div>
            </div>

            <!-- 步骤2：选择查询条件 -->
            <div class="step-card">
              <div class="step-header">
                <span class="step-number">2</span>
                <span class="step-title">选择查询条件</span>
              </div>
              <div class="step-content">
                <div class="condition-tips">
                  <div class="tip-row">
                    <i class="el-icon-warning-outline tip-icon"></i>
                    <span>请从左侧选择查询条件列(如姓名、身份证等，最多两个)移到右侧框中</span>
                  </div>
                  <div class="tip-row warning">
                    <i class="el-icon-warning tip-icon"></i>
                    <span>特别注意：必须选择每个人都有数据的列，否则部分人将无法查询</span>
                  </div>
                </div>

                <div class="transfer-wrapper">
                  <el-transfer 
                    target-order="push" 
                    v-model="selectedSearchCondition" 
                    :data="transferList" 
                    :titles="['可选的列', '已选的列']"
                    class="custom-transfer">
                  </el-transfer>
                </div>

                <!-- 手机端预览 -->
                <div v-if="selectedSearchCondition.length>0" class="preview-section">
                  <div class="preview-title">
                    <i class="el-icon-mobile-phone"></i>
                    <span>手机端输入查询条件效果预览</span>
                  </div>
                  <div class="preview-card">
                    <div v-if="selectedSearchCondition.length==1">
                      <div class="preview-item">
                        <div class="preview-label">{{selectedSearchCondition[0]}}</div>
                        <input class="preview-input" placeholder="这里是输入的位置" readonly/>
                      </div>
                    </div>
                    <div v-if="selectedSearchCondition.length==2">
                      <div class="preview-item">
                        <div class="preview-label">{{selectedSearchCondition[0]}}</div>
                        <input class="preview-input" placeholder="这里是输入的位置" readonly/>
                      </div>
                      <div class="preview-item">
                        <div class="preview-label">{{selectedSearchCondition[1]}}</div>
                        <input class="preview-input" placeholder="这里是输入的位置" readonly/>
                      </div>
                      <div class="preview-note">
                        <i class="el-icon-info"></i>
                        <span>注：查询条件先后顺序可通过调整右侧框中的顺序进行调整</span>
                      </div>
                    </div>
                    <div v-if="selectedSearchCondition.length>2" class="preview-error">
                      <i class="el-icon-circle-close"></i>
                      <span>最多选择2个查询条件，请重新选择！</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 步骤3：补充说明 -->
            <div class="step-card">
              <div class="step-header">
                <span class="step-number">3</span>
                <span class="step-title">补充说明</span>
              </div>
              <div class="step-content">
                <el-input 
                  type="textarea" 
                  v-model="search_description" 
                  placeholder="输入查询说明、通知、注意事项等，会显示在查询界面首页，所有的人都一样"
                  :rows="3"
                  class="custom-textarea">
                </el-input>
              </div>
            </div>

            <!-- 提交按钮区域 -->
            <div class="action-section">
              <el-button 
                type="primary" 
                size="medium" 
                @click="nextStep" 
                class="submit-button">
                <i class="el-icon-check"></i>
                <span>设置完成，确认无误，点我立即导入</span>
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 确认对话框 -->
    <el-dialog
      title="操作确认"
      :visible.sync="setConditionConfirmVisible"
      width="420px"
      class="confirm-dialog"
      :close-on-click-modal="false">
      <div class="dialog-content">
        <div class="dialog-icon">
          <i class="el-icon-question"></i>
        </div>
        <div class="dialog-message">
          查询人需要正确输入 <span class="highlight">{{selectedSearchCondition}}</span> 才能查到结果，确定吗？
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setConditionConfirmVisible = false" class="cancel-button">取消</el-button>
        <el-button @click="nextStepAction()" type="primary" class="confirm-button">确定，立即导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        username: '',
        form_name: '',
        dataList: [],
        headList: [],

        transferList: [],
        selectedSearchCondition: [],
        finalConditions: [],

        selectedCondition: '',

        input_pages: '1',
        import_data: '',

        show_public: false,
        is_public: '0',
        search_description: '',
        selected_column_names: '',
        message: '',

        setConditionConfirmVisible: false,

        form_id: '',

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session

      console.log('最后一部导入',this.username)

      this.dataList = JSON.parse(this.$route.params.dataList)
      this.headList = JSON.parse(this.$route.params.headList)
      this.import_data = this.$route.params.import_data

      this.transferList = []
      for (var i = 0; i < this.headList.length; i++) {
        let item = {
          key: this.headList[i].label,
          label: this.headList[i].label,
          disabled: false
        }
        this.transferList.push(item)
      }

      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      if (this.form_id) {
        this.form_name = this.$route.params.form_name
      }
    },
    methods: {
      nextStep() {

        let that = this

        if (Utils.isEmpty(this.form_name)) {
          this.$alert('请输入查询名称')
          return
        }

        if (this.selectedSearchCondition.length === 0) {
          this.message = '至少选一个查询条件,如姓名、工号、学号等(最多2个)'
          this.$alert(this.message)
          return
        }

        if (this.selectedSearchCondition.length > 2) {
          this.message = '不要超过2个查询条件(最多2个),否则录入会很困难,请重新选择！'
          this.$alert(this.message)
          return
        }

        this.setConditionConfirmVisible = true

      },
      nextStepAction() {

        let that = this

        if (this.show_public) {
          that.is_public = '1'
        } else {
          that.is_public = '0'
        }


        var jsonConditionStr = JSON.stringify(that.selectedSearchCondition)

        var requestUrl = '/wansearch/web/_import_excel_form_data.jsp'

        let data = {
          username: that.username,
          form_name: that.form_name,
          head_list: JSON.stringify(that.headList),
          data_list: JSON.stringify(that.dataList),

          input_pages: that.input_pages,
          import_data: that.import_data,


          search_conditions: jsonConditionStr,
          public_condition: that.is_public,
          search_description: that.search_description,

          form_id: that.form_id
        }

        var qs = require('qs')

        const load = this.$loading({
          lock: true,
          text: '正在导入,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            that.$message({
              duration: 5000,
              message: '导入成功！如需修改，请在Excel中修改好后重新导入即可！',
              type: 'success'
            })
            load.close()

            if (that.import_data === '1') {
              that.$router.push({
                path: '/query_list',
                params: {
                  username: that.username
                }
              })
            }
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      back() {
        this.$router.back()
      },
      hasFixColumn() {
        let that = this
        var hasFixed = false

        for (var i = 0; i < that.headList.size(); i++) {
          let column = that.headList[i]
          if (column.can_edit == '0') {
            hasFixed = true
            break
          }
        }

        return hasFixed
      },
      showPublicTips() {
        let that = this

        this.finalConditions = []

        var tstr = ''

        for (var i = 0; i < that.selectedSearchCondition.length; i++) {

          var str = ''
          if (i === 0) {
            str = that.selectedSearchCondition[0]
            tstr = str
          } else {
            str = that.selectedSearchCondition[i]
            tstr = tstr + '、' + str
          }

        }

        if (tstr !== '') {
          tstr = '"' + tstr + '"'
        }

        var tempstr = '公开' + tstr + '条件的值,便于领表人选入查询条件(不涉及隐私时使用)'

        return tempstr
      },
      getTransferLabel(field_name) {
        console.log(this.transferList, field_name)

        var label = ''
        for (var i = 0; i < this.transferList.length; i++) {
          let obj = this.transferList[i]
          if (obj.key == field_name) {
            label = obj.label
            break
          }
        }

        return label
      }

    }
  }
</script>

<style scoped>
/* ==================== 页面整体布局 ==================== */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
}

.content-wrapper {
  padding: 20px 30px;
  max-width: 1000px;
  margin: 0 auto;
}

/* ==================== 页面标题 ==================== */
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 25px 30px;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
}

.header-icon {
  font-size: 26px;
}

/* ==================== 信息提示卡片 ==================== */
.info-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #fff;
  border-radius: 10px;
  padding: 18px 22px;
  margin-bottom: 25px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-left: 4px solid #667eea;
}

.info-icon {
  font-size: 28px;
  color: #667eea;
  flex-shrink: 0;
}

.info-text {
  font-size: 15px;
  color: #495057;
  line-height: 1.6;
}

.info-text .highlight {
  color: #e74c3c;
  font-weight: 600;
  font-size: 16px;
}

/* ==================== 步骤卡片 ==================== */
.step-card {
  background: #fff;
  border-radius: 12px;
  padding: 22px 25px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.step-card:hover {
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);
}

.step-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.step-number {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.step-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

.step-title .required {
  color: #e74c3c;
  margin-left: 4px;
}

.step-content {
  padding-left: 40px;
}

/* ==================== 输入框样式 ==================== */
.custom-input >>> .el-input__inner {
  border-radius: 8px;
  border-color: #e8e8e8;
  padding: 12px 15px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.custom-input >>> .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.custom-textarea >>> .el-textarea__inner {
  border-radius: 8px;
  border-color: #e8e8e8;
  padding: 12px 15px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.custom-textarea >>> .el-textarea__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

/* ==================== 条件提示 ==================== */
.condition-tips {
  margin-bottom: 20px;
}

.tip-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 10px;
  padding: 10px 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.tip-row.warning {
  background: #fff5f5;
  color: #e74c3c;
  border-left: 3px solid #e74c3c;
}

.tip-icon {
  font-size: 16px;
  flex-shrink: 0;
}

/* ==================== 穿梭框样式 ==================== */
.transfer-wrapper {
  margin: 20px 0;
}

.custom-transfer >>> .el-transfer-panel {
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
}

.custom-transfer >>> .el-transfer-panel__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: none;
  color: #fff;
  font-weight: 500;
}

.custom-transfer >>> .el-transfer-panel__header .el-checkbox__label {
  color: #fff;
}

.custom-transfer >>> .el-transfer-panel__body {
  height: 280px;
}

.custom-transfer >>> .el-transfer-panel__list.is-filterable {
  padding-top: 10px;
}

.custom-transfer >>> .el-transfer-panel__item {
  height: 36px;
  line-height: 36px;
  padding-left: 15px;
  border-radius: 6px;
  margin: 2px 8px;
}

.custom-transfer >>> .el-transfer-panel__item:hover {
  background: rgba(102, 126, 234, 0.08);
}

.custom-transfer >>> .el-transfer-panel__item.is-checked {
  background: rgba(102, 126, 234, 0.15);
  color: #667eea;
}

.custom-transfer >>> .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 6px;
}

.custom-transfer >>> .el-button--primary:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* ==================== 手机端预览 ==================== */
.preview-section {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px dashed #e8e8e8;
}

.preview-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 15px;
}

.preview-title i {
  font-size: 20px;
  color: #667eea;
}

.preview-card {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 20px 25px;
  max-width: 400px;
}

.preview-item {
  margin-bottom: 15px;
}

.preview-item:last-child {
  margin-bottom: 0;
}

.preview-label {
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.preview-input {
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  background: #fff;
  box-sizing: border-box;
}

.preview-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 11px;
  color: #adb5bd;
  margin-top: 15px;
  line-height: 1.5;
}

.preview-note i {
  flex-shrink: 0;
  margin-top: 2px;
}

.preview-error {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #e74c3c;
  font-size: 13px;
  font-weight: 500;
}

.preview-error i {
  font-size: 18px;
}

/* ==================== 提交按钮 ==================== */
.action-section {
  display: flex;
  justify-content: center;
  padding: 30px 0 50px;
}

.submit-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  padding: 14px 50px;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.35);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
}

.submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.45);
  background: linear-gradient(135deg, #5a71d6 0%, #6a4190 100%);
}

.submit-button i {
  font-size: 18px;
}

/* ==================== 对话框样式 ==================== */
.confirm-dialog >>> .el-dialog {
  border-radius: 14px;
  overflow: hidden;
}

.confirm-dialog >>> .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 18px 25px;
}

.confirm-dialog >>> .el-dialog__title {
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}

.confirm-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.confirm-dialog >>> .el-dialog__body {
  padding: 30px 25px;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.dialog-icon {
  width: 60px;
  height: 60px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.dialog-icon i {
  font-size: 32px;
  color: #667eea;
}

.dialog-message {
  font-size: 14px;
  color: #495057;
  line-height: 1.7;
}

.dialog-message .highlight {
  color: #667eea;
  font-weight: 600;
}

.confirm-dialog >>> .el-dialog__footer {
  padding: 15px 25px 22px;
  border-top: 1px solid #f0f0f0;
}

.cancel-button {
  border-radius: 8px;
  padding: 10px 25px;
  font-size: 14px;
  border-color: #d9d9d9;
  color: #6c757d;
}

.cancel-button:hover {
  border-color: #667eea;
  color: #667eea;
}

.confirm-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 10px 25px;
  font-size: 14px;
}

.confirm-button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* ==================== 响应式设计 ==================== */
@media screen and (max-width: 1200px) {
  .content-wrapper {
    padding: 15px 20px;
  }
  
  .step-content {
    padding-left: 0;
  }
}

@media screen and (max-width: 992px) {
  .custom-transfer >>> .el-transfer-panel__body {
    height: 240px;
  }
  
  .preview-card {
    max-width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .content-wrapper {
    padding: 10px 15px;
  }
  
  .page-header {
    padding: 18px 20px;
  }
  
  .header-content {
    font-size: 18px;
  }
  
  .step-card {
    padding: 15px 18px;
  }
  
  .step-title {
    font-size: 14px;
  }
  
  .step-number {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
  
  .custom-transfer >>> .el-transfer-panel {
    width: 45%;
  }
  
  .submit-button {
    width: 100%;
    padding: 12px 30px;
  }
  
  .info-card {
    flex-direction: column;
    text-align: center;
    padding: 15px;
  }
  
  .info-text {
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .page-header {
    padding: 15px;
    border-radius: 10px;
  }
  
  .header-content {
    font-size: 16px;
    gap: 8px;
  }
  
  .header-icon {
    font-size: 20px;
  }
  
  .tip-row {
    font-size: 12px;
    padding: 8px 12px;
  }
  
  .custom-transfer >>> .el-transfer-panel__body {
    height: 200px;
  }
  
  .preview-card {
    padding: 15px;
  }
  
  .preview-label {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/excel_data_import_final_step.vue